import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Table } from 'primeng/table';
import { User } from 'src/app/models';
import { SlingConfigService } from 'src/app/services/sling-config.service';
import { UserService } from 'src/app/services/user.service';
import { FormatUtil } from 'src/app/utils/format.util';
import { MessageUtil } from 'src/app/utils/message.util';
import { StorageUtil } from 'src/app/utils/storage.util';

@Component({
  selector: 'app-user-app-tab',
  templateUrl: './user-app-tab.component.html',
  styleUrls: ['./user-app-tab.component.scss']
})
export class UserAppTabComponent implements OnInit {

  @Output()
  eventsUser = new EventEmitter();
  
  @ViewChild('tt') table: Table;

  numberOfRows = 10;
  users: any[] = [];
  usersTable: any[] = [];
  userStatus: boolean = null;

  constructor(
    private slingConfigService: SlingConfigService,
    private spinner: NgxSpinnerService,
    private userService: UserService,
    private messageUtil: MessageUtil
  ) { }

  ngOnInit(): void {
    this.loadSlingConfig();
    this.fillUsersTable();
  }

  private loadSlingConfig(): void {
    this.slingConfigService.getSlingConfig().subscribe(
      (data) => {
        const slingConfig = data[0];
        this.numberOfRows = slingConfig != null ? slingConfig.numberOfRecordsPerPage : 10;
      },
      (error) => null
    );
  }

  filterGlobal(value: string): void {
    this.usersTable = this.users.filter(
      (u) =>
        (FormatUtil.getNotAccents(u.name).toUpperCase().includes(FormatUtil.getNotAccents(value).toUpperCase()) ||
          u.name.toUpperCase().includes(value.toUpperCase())
        ) ||
        (u.email.toUpperCase().includes(value.toUpperCase())) ||
        (u.username.toUpperCase().includes(value.toUpperCase())) ||
        (u.platform && u.platform.toUpperCase().includes(value.toUpperCase())) ||
        (u.applicationVersion && u.applicationVersion.toUpperCase().includes(value.toUpperCase()))
    );
  }

  fillUsersTable(): void {
    this.spinner.show();
    this.userService.getAllUsersApp().subscribe({
      next: (response: any) => {
        // Usar diretamente a resposta do novo endpoint
        this.users = response;
        this.usersTable = this.users;
      },
      error: (error) => {
        const exception = error.error.data.exception;
        this.messageUtil.generateMessage(exception.type, exception.title, exception.message);
      },
      complete: () => this.spinner.hide()
    });
  }

  openUserFormDialog(idUser?: number): void {
    this.eventsUser.emit({ isDelete: false, id: idUser, origin: 'TabApp' });
  }

  openUserDeleteConfirmDialog(idUser: number): void {
    this.eventsUser.emit({ isDelete: true, id: idUser, origin: 'TabApp' });
  }

  // Método para filtrar usuários com base no status
  filterByStatus(value: boolean | null): void {
    if (value === null) {
      // Caso "Todos": mostrar todos os usuários
      this.usersTable = [...this.users];
    } else if (value === true) {
      // Caso "Ativo": mostrar apenas usuários com AMBOS os status ativos
      this.usersTable = this.users.filter(user => user.userActive === true && user.customerActive === true);
    } else {
      // Caso "Inativo": mostrar usuários com PELO MENOS UM dos status inativos
      this.usersTable = this.users.filter(user => user.userActive === false || user.customerActive === false);
    }
  }
}

